export const BUSINESS_MODELS = [
    {
        id: 'saas_b2b',
        name: 'SaaS B2B',
        shortName: 'SaaS',
        description: 'Software as a Service voltado para empresas.',
        icon: '🏢',
        color: '#6366f1',
        tags: ['recorrente', 'alta-margem', 'tech'],
        notes: {
            market_demand: 9,
            market_growth: 9,
            market_saturation: 7,
            market_competition: 6,
            market_trend: 9,
            fin_margin: 8,
            fin_ticket: 9,
            fin_recurring: 10,
            fin_cac: 7,
            fin_ltv: 9,
            fin_roi: 8,
            op_complexity: 5,
            op_automation: 9,
            op_team: 6,
            op_support: 6,
            mkt_acquisition: 6,
            mkt_organic: 7,
            mkt_brand: 7,
            scale_operational: 9,
            scale_tech: 10,
            scale_international: 8,
            risk_platform: 5,
            risk_legal: 7,
            risk_copiability: 4,
        },
    },
    {
        id: 'micro_saas_b2c',
        name: 'Micro-SaaS B2C',
        shortName: 'Micro-SaaS',
        description: 'Produtos digitais pequenos para consumidores individuais.',
        icon: '🛠️',
        color: '#a855f7',
        tags: ['recorrente', 'baixa-complexidade', 'niche'],
        notes: {
            market_demand: 7,
            market_growth: 8,
            market_saturation: 8,
            market_competition: 8,
            market_trend: 7,
            fin_margin: 9,
            fin_ticket: 7,
            fin_recurring: 9,
            fin_cac: 6,
            fin_ltv: 7,
            fin_roi: 8,
            op_complexity: 3,
            op_automation: 8,
            op_team: 3,
            op_support: 4,
            mkt_acquisition: 5,
            mkt_organic: 8,
            mkt_brand: 6,
            scale_operational: 8,
            scale_tech: 9,
            scale_international: 6,
            risk_platform: 4,
            risk_legal: 6,
            risk_copiability: 6,
        },
    },
    {
        id: 'dropshipping',
        name: 'Dropshipping',
        shortName: 'Dropship',
        description: 'Varejo online sem estoque físico.',
        icon: '📦',
        color: '#06b6d4',
        tags: ['low-investment', 'logistica', 'physical'],
        notes: {
            market_demand: 8,
            market_growth: 6,
            market_saturation: 9,
            market_competition: 10,
            market_trend: 5,
            fin_margin: 5,
            fin_ticket: 6,
            fin_recurring: 2,
            fin_cac: 8,
            fin_ltv: 5,
            fin_roi: 5,
            op_complexity: 7,
            op_automation: 5,
            op_team: 4,
            op_support: 7,
            mkt_acquisition: 6,
            mkt_organic: 4,
            mkt_brand: 4,
            scale_operational: 6,
            scale_tech: 5,
            scale_international: 7,
            risk_platform: 9,
            risk_legal: 8,
            risk_copiability: 9,
        },
    },
    {
        id: 'ecommerce',
        name: 'E-commerce Próprio',
        shortName: 'E-com',
        description: 'Loja online com controle total de estoque e marca.',
        icon: '🛒',
        color: '#22c55e',
        tags: ['marca-propria', 'high-control', 'inventory'],
        notes: {
            market_demand: 9,
            market_growth: 7,
            market_saturation: 7,
            market_competition: 8,
            market_trend: 6,
            fin_margin: 6,
            fin_ticket: 8,
            fin_recurring: 3,
            fin_cac: 7,
            fin_ltv: 8,
            fin_roi: 6,
            op_complexity: 8,
            op_automation: 6,
            op_team: 7,
            op_support: 8,
            mkt_acquisition: 7,
            mkt_organic: 6,
            mkt_brand: 9,
            scale_operational: 7,
            scale_tech: 7,
            scale_international: 8,
            risk_platform: 6,
            risk_legal: 7,
            risk_copiability: 7,
        },
    },
    {
        id: 'infoproducts',
        name: 'Infoprodutos',
        shortName: 'Info',
        description: 'Cursos, ebooks, vídeos educacionais digitais.',
        icon: '📚',
        color: '#f59e0b',
        tags: ['knowledge', 'scalable', 'education'],
        notes: {
            market_demand: 8,
            market_growth: 9,
            market_saturation: 6,
            market_competition: 6,
            market_trend: 9,
            fin_margin: 9,
            fin_ticket: 7,
            fin_recurring: 4,
            fin_cac: 7,
            fin_ltv: 7,
            fin_roi: 8,
            op_complexity: 5,
            op_automation: 8,
            op_team: 4,
            op_support: 5,
            mkt_acquisition: 8,
            mkt_organic: 9,
            mkt_brand: 8,
            scale_operational: 9,
            scale_tech: 8,
            scale_international: 9,
            risk_platform: 7,
            risk_legal: 6,
            risk_copiability: 7,
        },
    },
    {
        id: 'community',
        name: 'Comunidade Paga',
        shortName: 'Community',
        description: 'Grupos exclusivos com conteúdo e networking.',
        icon: '👥',
        color: '#14b8a8',
        tags: ['recorrente', 'engajamento', 'networking'],
        notes: {
            market_demand: 7,
            market_growth: 8,
            market_saturation: 7,
            market_competition: 6,
            market_trend: 7,
            fin_margin: 8,
            fin_ticket: 6,
            fin_recurring: 8,
            fin_cac: 6,
            fin_ltv: 7,
            fin_roi: 7,
            op_complexity: 6,
            op_automation: 6,
            op_team: 5,
            op_support: 9,
            mkt_acquisition: 5,
            mkt_organic: 6,
            mkt_brand: 7,
            scale_operational: 6,
            scale_tech: 5,
            scale_international: 7,
            risk_platform: 8,
            risk_legal: 5,
            risk_copiability: 8,
        },
    },
    {
        id: 'newsletter',
        name: 'Newsletter Paga',
        shortName: 'Newsletter',
        description: 'Conteúdo premium por assinatura de e-mail.',
        icon: '📧',
        color: '#fb7185',
        tags: ['recorrente', 'writing', 'audience'],
        notes: {
            market_demand: 6,
            market_growth: 7,
            market_saturation: 8,
            market_competition: 7,
            market_trend: 6,
            fin_margin: 9,
            fin_ticket: 5,
            fin_recurring: 7,
            fin_cac: 5,
            fin_ltv: 6,
            fin_roi: 7,
            op_complexity: 2,
            op_automation: 5,
            op_team: 1,
            op_support: 3,
            mkt_acquisition: 4,
            mkt_organic: 8,
            mkt_brand: 6,
            scale_operational: 7,
            scale_tech: 4,
            scale_international: 8,
            risk_platform: 7,
            risk_legal: 6,
            risk_copiability: 6,
        },
    },
    {
        id: 'consulting',
        name: 'Consultoria Especializada',
        shortName: 'Consultoria',
        description: 'Serviços de consultoria em nicho específico.',
        icon: '👔',
        color: '#8b5cf6',
        tags: ['high-value', 'expertise', 'service'],
        notes: {
            market_demand: 8,
            market_growth: 6,
            market_saturation: 6,
            market_competition: 7,
            market_trend: 5,
            fin_margin: 7,
            fin_ticket: 9,
            fin_recurring: 4,
            fin_cac: 5,
            fin_ltv: 8,
            fin_roi: 6,
            op_complexity: 6,
            op_automation: 3,
            op_team: 4,
            op_support: 6,
            mkt_acquisition: 6,
            mkt_organic: 5,
            mkt_brand: 8,
            scale_operational: 3,
            scale_tech: 2,
            scale_international: 5,
            risk_platform: 4,
            risk_legal: 6,
            risk_copiability: 8,
        },
    },
    {
        id: 'agency',
        name: 'Agência de Serviços',
        shortName: 'Agência',
        description: 'Prestação de serviços comoDesign, marketing, dev sob demanda.',
        icon: '🏢',
        color: '#ec4899',
        tags: ['service', 'time-for-money', 'flexible'],
        notes: {
            market_demand: 9,
            market_growth: 5,
            market_saturation: 8,
            market_competition: 9,
            market_trend: 4,
            fin_margin: 5,
            fin_ticket: 7,
            fin_recurring: 3,
            fin_cac: 6,
            fin_ltv: 6,
            fin_roi: 5,
            op_complexity: 7,
            op_automation: 4,
            op_team: 6,
            op_support: 7,
            mkt_acquisition: 7,
            mkt_organic: 4,
            mkt_brand: 5,
            scale_operational: 4,
            scale_tech: 3,
            scale_international: 6,
            risk_platform: 5,
            risk_legal: 6,
            risk_copiability: 9,
        },
    },
    {
        id: 'productized_freelance',
        name: 'Productized Freelancing',
        shortName: 'Prod. Freelance',
        description: 'Serviços com escopo fixo e entrega padronizada.',
        icon: '🎯',
        color: '#f97316',
        tags: ['semi-passive', 'defined-scope', 'scale'],
        notes: {
            market_demand: 7,
            market_growth: 7,
            market_saturation: 7,
            market_competition: 8,
            market_trend: 6,
            fin_margin: 7,
            fin_ticket: 6,
            fin_recurring: 3,
            fin_cac: 5,
            fin_ltv: 7,
            fin_roi: 7,
            op_complexity: 4,
            op_automation: 5,
            op_team: 2,
            op_support: 4,
            mkt_acquisition: 6,
            mkt_organic: 6,
            mkt_brand: 6,
            scale_operational: 5,
            scale_tech: 4,
            scale_international: 7,
            risk_platform: 5,
            risk_legal: 5,
            risk_copiability: 7,
        },
    },
    {
        id: 'marketplace',
        name: 'Marketplace de Nicho',
        shortName: 'Marketplace',
        description: 'Plataforma conectando oferentes e demandantes.',
        icon: '🏪',
        color: '#607489',
        tags: ['network-effects', 'two-sided', 'complex'],
        notes: {
            market_demand: 6,
            market_growth: 6,
            market_saturation: 8,
            market_competition: 8,
            market_trend: 5,
            fin_margin: 4,
            fin_ticket: 8,
            fin_recurring: 5,
            fin_cac: 9,
            fin_ltv: 8,
            fin_roi: 4,
            op_complexity: 9,
            op_automation: 6,
            op_team: 8,
            op_support: 8,
            mkt_acquisition: 4,
            mkt_organic: 5,
            mkt_brand: 7,
            scale_operational: 7,
            scale_tech: 8,
            scale_international: 8,
            risk_platform: 7,
            risk_legal: 8,
            risk_copiability: 8,
        },
    },
    {
        id: 'cursos_platform',
        name: 'Plataforma de Cursos',
        shortName: 'Cursos',
        description: 'Marketplace ou plataforma própria de ensino.',
        icon: '🎓',
        color: '#16a34a',
        tags: ['education', 'scalable', 'content'],
        notes: {
            market_demand: 8,
            market_growth: 8,
            market_saturation: 7,
            market_competition: 6,
            market_trend: 8,
            fin_margin: 8,
            fin_ticket: 8,
            fin_recurring: 5,
            fin_cac: 7,
            fin_ltv: 7,
            fin_roi: 7,
            op_complexity: 7,
            op_automation: 7,
            op_team: 6,
            op_support: 6,
            mkt_acquisition: 6,
            mkt_organic: 8,
            mkt_brand: 8,
            scale_operational: 8,
            scale_tech: 7,
            scale_international: 9,
            risk_platform: 6,
            risk_legal: 6,
            risk_copiability: 7,
        },
    },
    {
        id: 'youtube',
        name: 'YouTube Monetizado',
        shortName: 'YouTube',
        description: 'Canal de vídeos com AdSense, memberships e afiliados.',
        icon: '📺',
        color: '#ef4444',
        tags: ['passive', 'content', 'ads'],
        notes: {
            market_demand: 9,
            market_growth: 5,
            market_saturation: 9,
            market_competition: 10,
            market_trend: 4,
            fin_margin: 7,
            fin_ticket: 4,
            fin_recurring: 3,
            fin_cac: 2,
            fin_ltv: 5,
            fin_roi: 6,
            op_complexity: 6,
            op_automation: 4,
            op_team: 5,
            op_support: 3,
            mkt_acquisition: 5,
            mkt_organic: 9,
            mkt_brand: 6,
            scale_operational: 9,
            scale_tech: 6,
            scale_international: 10,
            risk_platform: 10,
            risk_legal: 5,
            risk_copiability: 8,
        },
    },
    {
        id: 'affiliate',
        name: 'Afiliados/Performance',
        shortName: 'Afiliados',
        description: 'Promover produtos de terceiros por comissão.',
        icon: '🤝',
        color: '#14b8a8',
        tags: ['commission', 'low-investment', 'marketing'],
        notes: {
            market_demand: 8,
            market_growth: 6,
            market_saturation: 7,
            market_competition: 8,
            market_trend: 5,
            fin_margin: 3,
            fin_ticket: 5,
            fin_recurring: 2,
            fin_cac: 4,
            fin_ltv: 4,
            fin_roi: 5,
            op_complexity: 3,
            op_automation: 5,
            op_team: 1,
            op_support: 2,
            mkt_acquisition: 6,
            mkt_organic: 7,
            mkt_brand: 4,
            scale_operational: 8,
            scale_tech: 3,
            scale_international: 8,
            risk_platform: 9,
            risk_legal: 6,
            risk_copiability: 9,
        },
    },
    {
        id: 'app_plugin',
        name: 'Apps/Plugins',
        shortName: 'Apps',
        description: 'Aplicativos ou plugins para marketplaces (Apple, Chrome, etc).',
        icon: '📱',
        color: '#8b5cf6',
        tags: ['tech', 'scalable', 'app-store'],
        notes: {
            market_demand: 7,
            market_growth: 7,
            market_saturation: 6,
            market_competition: 7,
            market_trend: 7,
            fin_margin: 8,
            fin_ticket: 6,
            fin_recurring: 6,
            fin_cac: 7,
            fin_ltv: 6,
            fin_roi: 7,
            op_complexity: 8,
            op_automation: 6,
            op_team: 5,
            op_support: 5,
            mkt_acquisition: 5,
            mkt_organic: 6,
            mkt_brand: 5,
            scale_operational: 8,
            scale_tech: 8,
            scale_international: 8,
            risk_platform: 6,
            risk_legal: 7,
            risk_copiability: 6,
        },
    },
];
